export default __webpack_public_path__ + "static/media/mti-macapp-theatre.d2ed42ec.png";